package search.global

import dev.fritz2.core.RootStore
import kotlinx.coroutines.Job

class SearchInputFieldStore : RootStore<String>(
    initialData = "",
    job = Job(),
) {

    var lastQuery: String = ""

    val backToLastQuery = handle { _ ->
        lastQuery
    }

    val clearLastAndWipe = handle {
        lastQuery = ""
        ""
    }

    val storeLastAndWipe = handle { current ->
        lastQuery = current
        ""
    }
}
